import { gql } from '@apollo/client';

/**
 * 区域/司机筛选项按需搜索。
 *
 * 原先这两类选项由 getDeliveryProgressMonitoringOfSlaFilterOptions 聚合 SLA 大表得出（约 9.6s），
 * 现改为按关键词查主库 area / account（数万行）。因此选项不再局限于"当前条件下实际有数据"的范围，
 * 可能选中一个该时间段无数据的区域/司机，此时列表为空属预期行为。
 */
export const SEARCH_DELIVERY_FILTER_AREA_OPTIONS = gql`
    query SearchDeliveryFilterAreaOptions(
        $hubId: Long
        $warehouseIds: [Long!]
        $keyword: String
        $limit: Int
    ) {
        searchDeliveryFilterAreaOptions(hubId: $hubId, warehouseIds: $warehouseIds, keyword: $keyword, limit: $limit) {
            id
            name
        }
    }
`;

export const SEARCH_DELIVERY_FILTER_DRIVER_OPTIONS = gql`
    query SearchDeliveryFilterDriverOptions(
        $hubId: Long
        $warehouseIds: [Long!]
        $dspIds: [Long!]
        $keyword: String
        $limit: Int
    ) {
        searchDeliveryFilterDriverOptions(
            hubId: $hubId
            warehouseIds: $warehouseIds
            dspIds: $dspIds
            keyword: $keyword
            limit: $limit
        ) {
            id
            name
        }
    }
`;

/** DSP 端同名接口（权限注解不同，返回结构一致） */
export const SEARCH_DELIVERY_FILTER_AREA_OPTIONS_FOR_DSP = gql`
    query SearchDeliveryFilterAreaOptionsForDsp(
        $hubId: Long
        $warehouseIds: [Long!]
        $keyword: String
        $limit: Int
    ) {
        searchDeliveryFilterAreaOptionsForDsp(
            hubId: $hubId
            warehouseIds: $warehouseIds
            keyword: $keyword
            limit: $limit
        ) {
            id
            name
        }
    }
`;

export const SEARCH_DELIVERY_FILTER_DRIVER_OPTIONS_FOR_DSP = gql`
    query SearchDeliveryFilterDriverOptionsForDsp(
        $hubId: Long
        $warehouseIds: [Long!]
        $dspIds: [Long!]
        $keyword: String
        $limit: Int
    ) {
        searchDeliveryFilterDriverOptionsForDsp(
            hubId: $hubId
            warehouseIds: $warehouseIds
            dspIds: $dspIds
            keyword: $keyword
            limit: $limit
        ) {
            id
            name
        }
    }
`;

/** DSP 筛选项按需搜索：范围为 hubId / warehouseIds 通过 warehouse_dsp 关联到的 DSP */
export const SEARCH_DELIVERY_FILTER_DSP_OPTIONS = gql`
    query SearchDeliveryFilterDspOptions(
        $hubId: Long
        $warehouseIds: [Long!]
        $keyword: String
        $limit: Int
    ) {
        searchDeliveryFilterDspOptions(
            hubId: $hubId
            warehouseIds: $warehouseIds
            keyword: $keyword
            limit: $limit
        ) {
            id
            name
        }
    }
`;

export const SEARCH_DELIVERY_FILTER_DSP_OPTIONS_FOR_DSP = gql`
    query SearchDeliveryFilterDspOptionsForDsp(
        $hubId: Long
        $warehouseIds: [Long!]
        $keyword: String
        $limit: Int
    ) {
        searchDeliveryFilterDspOptionsForDsp(
            hubId: $hubId
            warehouseIds: $warehouseIds
            keyword: $keyword
            limit: $limit
        ) {
            id
            name
        }
    }
`;

export interface DeliveryFilterOption {
    id: number;
    name: string;
}

export interface SearchDeliveryFilterDspOptionsResponse {
    searchDeliveryFilterDspOptions: DeliveryFilterOption[];
}

export interface SearchDeliveryFilterDspOptionsForDspResponse {
    searchDeliveryFilterDspOptionsForDsp: DeliveryFilterOption[];
}

export interface SearchDeliveryFilterAreaOptionsResponse {
    searchDeliveryFilterAreaOptions: DeliveryFilterOption[];
}

export interface SearchDeliveryFilterDriverOptionsResponse {
    searchDeliveryFilterDriverOptions: DeliveryFilterOption[];
}

export interface SearchDeliveryFilterAreaOptionsForDspResponse {
    searchDeliveryFilterAreaOptionsForDsp: DeliveryFilterOption[];
}

export interface SearchDeliveryFilterDriverOptionsForDspResponse {
    searchDeliveryFilterDriverOptionsForDsp: DeliveryFilterOption[];
}

export interface SearchDeliveryFilterOptionsVariables {
    hubId?: number | null;
    warehouseIds?: number[] | null;
    dspIds?: number[] | null;
    keyword?: string | null;
    limit?: number;
}
